import React from 'react';

interface IFmsMyTaskContext {
  cancel: () => boolean,
};

const defaultState:IFmsMyTaskContext = {
  cancel: () => false,
};

const IFmsMyTaskContext = React.createContext<IFmsMyTaskContext>(defaultState);

export default IFmsMyTaskContext;
